import React, { Component } from 'react'
import styled from 'styled-components'
import { Card, Colors, Modal, Button } from 'advenio-components'
import PropTypes from 'prop-types'
import { Form } from 'formsy-react'
import { connect } from 'react-redux'
import { clone, path } from 'ramda'

import ProfileHeader from '../../Components/ProfileHeader'
import ParentProfileForm from '../../Components/ParentComponents/ParentProfileForm'
import InvoiceDataForm from '../../Components/ParentComponents/InvoiceDataForm'
import ClassroomActions, { Selectors } from '../../Data/Redux/ClassroomRedux'
import ErrorIsland from '../../Components/ErrorIsland'
import { compareFirstInSecondJSON, stringContainsExactlyOf, studentIsExternal } from '../../utils/Utils'

const PageContainer = styled(Card)`
  min-height: 80vh;
  width: 65%;
  margin-left: 5%;
`
const ParentHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 40px;
  padding: 8px;
  border-bottom: solid 1px ${Colors.gray200};
`
const ParentName = styled.span`
  margin-left: 16px;
  font-size: 16px;
`
const BackButton = styled.img`
  cursor: pointer;
`
const ErrorRow = styled.div`
  display: flex;
  justify-content: center;
`
const MailButton = styled(Button)`
  height: 42px;
  margin-right: 16px;
  font-size: 13px;
  padding: 10px 16px 10px 16px;
  @media (max-width:1300px) {
    height: 32px;
    margin-right: 8px;
    font-size: 12px;
    width: 60px;
    padding: 4px 8px 4px 8px;
  `
export const UsoCFDIKeys = [
  {'id':'G01','regimens':[601, 603, 606, 612, 620, 621, 622, 623, 624, 625,626]},
  {'id':'G02','regimens':[601, 603, 606, 612, 620, 621, 622, 623, 624, 625,626]},
  {'id':'G03','regimens':[601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626]},
  {'id':'I01','regimens':[601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626]},
  {'id':'I02','regimens':[601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626]},
  {'id':'I03','regimens':[601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626]},
  {'id':'I04','regimens':[601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626]},
  {'id':'I05','regimens':[601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626]},
  {'id':'I06','regimens':[601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626]},
  {'id':'I07','regimens':[601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626]},
  {'id':'I08','regimens':[601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626]},
  {'id':'D01','regimens':[605, 606, 608, 611, 612, 614, 607, 615, 625]},
  {'id':'D02','regimens':[605, 606, 608, 611, 612, 614, 607, 615, 625]},
  {'id':'D03','regimens':[605, 606, 608, 611, 612, 614, 607, 615, 625]},
  {'id':'D04','regimens':[605, 606, 608, 611, 612, 614, 607, 615, 625]},
  {'id':'D05','regimens':[605, 606, 608, 611, 612, 614, 607, 615, 625]},
  {'id':'D06','regimens':[605, 606, 608, 611, 612, 614, 607, 615, 625]},
  {'id':'D07','regimens':[605, 606, 608, 611, 612, 614, 607, 615, 625]},
  {'id':'D08','regimens':[605, 606, 608, 611, 612, 614, 607, 615, 625]},
  {'id':'D09','regimens':[605, 606, 608, 611, 612, 614, 607, 615, 625]},
  {'id':'D10','regimens':[605, 606, 608, 611, 612, 614, 607, 615, 625]},
  {'id':'S01','regimens':[601, 603, 605, 606, 608, 610, 611, 612, 614, 616, 620, 621, 622, 623, 624, 607, 615, 625, 626]},
  {'id':'CP01','regimens':[601, 603, 605, 606, 608, 610, 611, 612, 614, 616, 620, 621, 622, 623, 624, 607, 615, 625, 626]},
  {'id':'CN01','regimens':[605]},
];

class ParentProfile extends Component {

  state = {
    optionsRimgentFiscal:[{id:0,label:'Seleciona regimen fiscal',value:0}],
    parentSelected:0,
    flawSelecion:false
  }

  componentWillMount = () => {
    const { activeParentId, activeStudentId, getParentProfileRequest, parent } = this.props
    let updatedAtTime = ''

    if (path(['parent', 'tax_info'], this.props)) {
      updatedAtTime = parent.updated_at
    }
    if(parent.id !== this.state.parentSelected){
      this.setState({parentSelected:parent.id, optionsRimgentFiscal:[{id:0,label:'Seleciona regimen fiscal',value:0}]})
    }
    getParentProfileRequest(activeParentId, activeStudentId, updatedAtTime)
  }

  componentWillReceiveProps = ({ activeParentId, activeStudentId, parent }) => {
    if (Number(activeParentId) === Number(this.props.activeParentId)) {
      return false
    }

    let updatedAtTime = ''

    if ('tax_info' in parent) {
      updatedAtTime = parent.updated_at
    }
    if(parent.id !== this.state.parentSelected){
      this.setState({parentSelected:parent.id, optionsRimgentFiscal:[{id:0,label:'Seleciona regimen fiscal',value:0}]})
    }
    return this.props.getParentProfileRequest(activeParentId, activeStudentId, updatedAtTime)
  }

  componentDidMount(){
    const{ parent } = this.props
  }
  componentWillUnmount = () => {
    this.props.getStudentProfileErrorReset()
    this.setState({optionsRimgentFiscal:[{id:0,label:'Seleciona regimen fiscal',value:0}]})
  }

  onSubmit = (data) => {
    const { activeParentId, activeStudentId, updateParent, parent } = this.props
    const generalInfo = compareFirstInSecondJSON(data, parent)

    const taxInfo = compareFirstInSecondJSON(data.tax_info, parent.tax_info)
    const hasValues = Object.keys(taxInfo).filter(item => typeof taxInfo[item] !== "undefined")

    if (hasValues.length > 0 && data.tax_info.regimen_fiscal !== 0) {
      generalInfo.tax_info = taxInfo
    } else {
      delete generalInfo.tax_info
    }

    const phones = compareFirstInSecondJSON(data.contact_numbers, parent.contact_numbers)
    if (Object.keys(phones).length > 0) {
      generalInfo.contact_numbers = phones
    } else {
      delete generalInfo.contact_numbers
    }

    if (generalInfo.company_id === 'sin_empresa') {
      generalInfo.company_id = ''
    }

    if (Object.keys(generalInfo).length > 0) {
      updateParent(activeParentId, activeStudentId, generalInfo)
    }
  }

  changeUsoCFDI = ({target:{value}}) => {
      const { uso_cfdi, regimenFiscal } = this.props
      const [usoCFDI] = uso_cfdi.filter(uso => uso.id === Number(value))
      const [UsoCFDIKey] = UsoCFDIKeys.filter(key => key.id === usoCFDI.sat_key)
      let optionsRimgentFiscal =  [{id:0,label:'Seleciona regimen fiscal',value:0}].concat(clone(regimenFiscal.filter(regimen => UsoCFDIKey.regimens.includes(Number(regimen.sat_key))).map(regimenFiscal => ({
        id: regimenFiscal.sat_key,
        label: regimenFiscal.sat_key+' - '+regimenFiscal.name,
        value: regimenFiscal.sat_key,
      }))))
      this.setState({optionsRimgentFiscal})
  }

  renderRelationsOptions = () => (
    this.props.relations.map(relation => ({
      id: relation.id,
      label: relation.translations.es,
      value: relation.id,
    }))
  )

  renderRegimenOtions = () => (
    this.props.regimenFiscal.map(relation => ({
      id: relation.sat_key,
      label: relation.sat_key+' - '+relation.name,
      value: relation.sat_key,
    }))
  )

  renderUsoCFDIOtions = () => {
    const { student } = this.props
    let usoCFDI = this.props.uso_cfdi.filter(key => !stringContainsExactlyOf(key.sat_key,['CP01'])).map(relation => ({
      id: relation.id,
      label: relation.sat_key+' - '+relation.name,
      value: relation.id,
    }))
    if (student.tax_info !== undefined){
      usoCFDI = usoCFDI.filter(key => key.id === 21)
    } else{
      usoCFDI = usoCFDI.filter(key => key.id !== 21)
    }
    return usoCFDI
  }

  renderButton = () =>(
    [<MailButton
      key={'1'}
      primary
      onClick={()=>{this.props.sendMailInstitutional(this.props.activeParentId, this.props.activeStudentId)}}
      type={'button'}
      loading={this.props.loading_mail}
     disabled={!this.props.parent.email_institutional || this.props.loading_mail}
    >
      Reenviar Correo
    </MailButton>]
  )

  render() {
    const { parent, error, loading } = this.props
    const { optionsRimgentFiscal } = this.state

    if (!parent || loading || parent.tax_info === undefined) {
      return <Modal isOpened loading />
    }

    if( parent.tax_info !== undefined && parent.tax_info !== null && optionsRimgentFiscal.length === 1){
      const obj = {'target':{'value':parent.tax_info.uso_cfdi_id}}
      if(parent.tax_info.uso_cfdi_id !== null)
      {
        this.changeUsoCFDI(obj)
      }
    }

    const regimenOptions = this.renderRegimenOtions()
    return (
      <PageContainer>
        <Form
          ref={(form) => { this.form = form }}
          onSubmit={this.onSubmit}
        >
          <ParentHeader>
            <BackButton src="/assets/back_arrow_icon.svg" onClick={this.props.onBack} />
            <ParentName>
              {`${parent.first_name} ${parent.last_name_paternal}`}
            </ParentName>
          </ParentHeader>
          <ProfileHeader
            header="Perfíl"
            submit
            loading={loading}
            buttons={this.renderButton()}
          />
          {error && (
            <ErrorRow>
              <ErrorIsland error={error} />
            </ErrorRow>
          )}
          <ParentProfileForm info={parent} />
          <InvoiceDataForm info={parent.tax_info || {}} regimenOtions={ optionsRimgentFiscal} usoCFDIOptions={this.renderUsoCFDIOtions()} changeUsoCFDI={this.changeUsoCFDI} flawSelecion={this.state.flawSelecion}/>
        </Form>
      </PageContainer>
    )
  }
}

ParentProfile.propTypes = {
  parent: PropTypes.object,
  loading: PropTypes.bool,
  activeParentId: PropTypes.number.isRequired,
  activeStudentId: PropTypes.number.isRequired,
  getParentProfileRequest: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  updateParent: PropTypes.func.isRequired,
  error: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
  getStudentProfileErrorReset: PropTypes.func.isRequired,
}

ParentProfile.defaultProps = {
  parent: undefined,
  loading: false,
  error: null,
}

const mapStateToProps = state => ({
  loading: state.classrooms.getParent.fetching,
  parent: Selectors.activeParent(state),
  activeParentId: state.classrooms.activeParentId,
  activeStudentId: state.classrooms.activeStudentId,
  relations: state.relations.get.results,
  error: state.classrooms.get.error,
  regimenFiscal : state.regimen_fiscal.get.results,
  uso_cfdi : state.uso_cfdi.get.results,
  loading_mail: state.classrooms.sendRequest.fetching,
})

const mapDispatchToProps = dispatch => ({
  getParentProfileRequest: (activeParentId, timestamp) =>
    dispatch(ClassroomActions.getParentProfileRequest(activeParentId, timestamp)),
  updateParent: (activeParentId, activeStudentId, profile) =>
    dispatch(ClassroomActions.updateParentRequest(activeParentId, activeStudentId, profile)),
  getStudentProfileErrorReset: () => dispatch(ClassroomActions.getStudentProfileErrorReset()),
  sendMailInstitutional: (activeParentId, activeStudentId) => dispatch(ClassroomActions.sendMailInstitutionalRequest(activeParentId,activeStudentId)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ParentProfile)



// WEBPACK FOOTER //
// ./src/Containers/StudentProfile/ParentProfile.jsx